// import React from "react";
// import "./vendorbanner.css";
// import UseMediaQuery from "./../UseMediaQuery";
// import vendorImg3 from "../../../assets/vendor11.jpg";
// // import vendor1 from "../../../assets/vendorpage2.png";
// import vendor1 from "../../../assets/newImg/vendor8.png";

// const VendorBanner = () => {
//   const isMobile = UseMediaQuery("(max-width:768px)");
//   return (
//     <>
//       {isMobile ? (
//         <>
//           <div className="container-fulid  my-0">
//             <div className="container">
//               <div className="row ">
//                 <div className="col-md-6 ">
//                   <img src={vendor1} alt="vendorImg3" className="vendorImg3" />
//                 </div>
//                 <div className="col-md-6  my-0 ">
//                   {" "}
//                   <div className=" vendorBanMain  mt-3 ">
//                     <h3 className="vendormBanh1 ">
//                       Expanding Your{" "}
//                       <span className="purplemText">Business</span> Made Easy
//                     </h3>
//                     <p className="vendormBanP my-xl-4 my-lg-4 my-md-3 my-sm-3 my-1">
//                       Join <span className="vendormSpan">Mestry Circle</span>{" "}
//                       today and become a trusted partner in our professional
//                       network.
//                     </p>

//                     {/* <div className="col-12 mobileDflex ">
//                       <div className="d-flex my-xl-5 my-lg-5  my-3 ">
//                         <img
//                           src="https://hometriangle.com/images/svg/button-google-play.svg"
//                           alt=""
//                           className="triLogoImg mx-0"
//                         />
//                         <img
//                           src="https://hometriangle.com/images/svg/button-appstore.svg"
//                           alt=""
//                           className="triLogoImg "
//                         />
//                       </div>
//                     </div> */}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       ) : (
//         <>
//           {" "}
//           <div className="container-fulid  my-xxl-4 my-xl-3 my-lg-3 my-md-3  my-1 ">
//             <div
//               className="container secOneImg3"
//               style={{
//                 backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${vendor1})`,
//                 backgroundRepeat: "no-repeat",
//                 backgroundSize: "100% 100%",
//                 backgroundPosition: "center",
//                 borderRadius: "30px",
//               }}
//             >
//               <div className="row">
//                 <div className="col-12 vendorBanMain text-center">
//                   <h3 className="vendorBanh1 my-xl-4 my-lg-4 my-md-3 my-sm-3 my-1">
//                     Expanding Your Business Made Easy
//                   </h3>
//                   <p className="vendorBanP my-xl-4 my-lg-4 my-md-3 my-sm-3 my-1">
//                     Join <span className="vendormSpan">Mestry Circle</span>{" "}
//                     today and become a trusted partner in our professional
//                     network.
//                   </p>

//                   {/* <div className="vendorBanLogo my-xl-5 my-lg-5  my-3  ">
//                     <img
//                       src="https://hometriangle.com/images/svg/button-google-play.svg"
//                       alt=""
//                       className="vendorLogoImg1 rounded-5"
//                     />
//                     <img
//                       src="https://hometriangle.com/images/svg/button-appstore.svg"
//                       alt=""
//                       className="vendorLogoImg2 rounded-5"
//                     />
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}
//     </>
//   );
// };

// export default VendorBanner;

import React from "react";
import "./vendorbanner.css";
import UseMediaQuery from "./../UseMediaQuery";
import vendorImg3 from "../../../assets/vendor11.jpg";
// import vendor1 from "../../../assets/vendorpage2.png";
import vendor1 from "../../../assets/newImg/vendor8.png";
import vendor2 from "../../../assets/newImg/vendor6.png";

const VendorBanner = () => {
  const isMobile = UseMediaQuery("(max-width:768px)");
  return (
    <>
      <>
        {" "}
        <div className="container-fulid  mt-2 mb-xxl-5 mb-xl-3 mb-lg-3 mb-md-3  my-1 ">
          <div
            className="container secOneImg3"
            style={{
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${
                isMobile ? vendor2 : vendor1
              })`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              borderRadius: "30px",
            }}
          >
            <div className="row">
              <div className="col-12 vendorBanMain text-center">
                <h3 className="vendorBanh1 my-xl-4 my-lg-4 my-md-3 my-sm-3 my-1">
                  Expanding Your Business Made Easy
                </h3>
                <p className="vendorBanP my-xl-4 my-lg-4 my-md-3 my-sm-3 my-2">
                  Join <span className="vendormSpan">Mestry Circle</span> today
                  and become a trusted partner in our professional network.
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default VendorBanner;
